export enum LotState {
    Selling,
    Upcoming,
    Finished,
}
